jQuery(document).ready(function ($) {
    const categories = $('.post-filters__category');

    const post_grid = $('.post-grid__container');

    if (categories.length === 0) {
        return;
    }

    let active_category_list = [];

    $.fn.collectCategories = function () {
        active_category_list = [];

        this.each(function () {
            if ($(this).attr('data-active') === '1') {
                active_category_list.push($(this).attr('data-category'));
            }
        });

        return this;
    }

    $.fn.disableCategory = function () {
        this.removeAttr('data-active');
        return this;
    }

    $.fn.enableCategory = function () {
        this.attr('data-active', '1');
        return this;
    }

    $.fn.toggleCategory = function () {
        if (this.attr('data-active') === '1') {
            this.disableCategory();
            return this;
        }

        this.enableCategory();
        return this;
    }

    $.fn.getArticles = function () {
        const _this = this;

        $.ajax({
            url: blogs.ajax_url,
            type: 'POST',
            data: {
                filters: JSON.stringify(active_category_list),
                action: 'get_articles',
                nonce: blogs.nonce
            },

            beforeSend: function () {
                //_this.addClass('loading');

                console.log('getting articles...');
            },

            success: function (response) {
                _this.html(response.data.loop);
            },

            complete: function () {
                //_this.removeClass('loading');
            }
        });
    }

    function toggleCategory(event) {
        event.preventDefault();

        let old_category_list = active_category_list;

        const category_id = parseInt($(this).attr('data-category'));

        if (category_id === 0) {
            categories.disableCategory();
            $(this).enableCategory();
        }

        else {
            $('.post-filters__category[data-category="0"]').disableCategory();
            $(this).toggleCategory();
        }

        categories.collectCategories();

        if (active_category_list.length === 0) {
            $('.post-filters__category[data-category="0"]').enableCategory();
            categories.collectCategories();
        }

        if (active_category_list.sort().toString() !== old_category_list.sort().toString()) {
            post_grid.getArticles();
        }
    }

    categories.on('click', toggleCategory);

    categories.collectCategories();
});